import { createSlice } from '@reduxjs/toolkit';

// @since NEXT_VERSION
// Departments are a small, stable list read by both the Master Data grid and the Add/Edit User
// dialog, so it is fetched once and cached here rather than re-fetched on every dialog open.
const departmentSlice = createSlice({
  name: 'department',
  initialState: {
    rows: [],
  },
  reducers: {
    replaceData(state, action) {
      state.rows = action.payload;
    },
  },
});

export const departmentActions = departmentSlice.actions;

export default departmentSlice;
